<template>
  <div>
    <ejs-tab heightAdjustMode='None' :selected='treeSwitch'>
      <e-tabitems>
        <e-tabitem :header='headerOfMeasureObj' :content='contentOfMeasureObj'></e-tabitem>
        <e-tabitem :header='headerOfNe' :content='contentOfNe'></e-tabitem>
      </e-tabitems>
    </ejs-tab>
    <!-- 测量对象树 -->
    <div id="MeasureTreeForTask" style="display:none;">
      <MeasureTreeForTask @transferMeasureObj="transferMeasureObj" ref="MeasureTreeForTask"></MeasureTreeForTask>
    </div>
    <!-- 网元树 -->
    <div id="NeTreeForTask" style="display:none;">
      <NeTreeForTask @transferNe="transferNe" ref="NeTreeForTask" ></NeTreeForTask>
    </div>
  </div>
</template>

<script>
import MeasureTreeForTask from './MeasureTreeForTask';
import NeTreeForTask from './NeTreeForTask';

export default {
  name: 'NoRealTaskManagement',
  components: {
    NeTreeForTask,
    MeasureTreeForTask
  },
  data() {
    return {
      headerOfMeasureObj: {
        text: this.$t('Pm.measurementObject')
      },
      headerOfNe: {
        text: this.$t('Pm.resource')
      },
      contentOfMeasureObj: '#MeasureTreeForTask',
      contentOfNe: '#NeTreeForTask',
    };
  },
  methods: {
    // 测量对象树点击节点信息事件发布
    transferMeasureObj(msg) {
      this.$emit('transferMeasureObj', msg);
    },

    // 网元树点击节点信息事件发布
    transferNe(msg) {
      this.$emit('transferNe', msg);
    },

    // 管理树类型切换事件发布
    treeSwitch(msg) {
      if (msg.selectedIndex == 0) {
        this.$refs.MeasureTreeForTask.getMeasureObjectTree();
      } else {
        this.$refs.NeTreeForTask.getNeTree();
      }
      this.$emit('changeTable', msg.selectedIndex + 1);
    }
  }
};
</script>

<style>

</style>
